import {
    FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_REQUEST,
    FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_FAILURE,
    FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_SUCCESS
} from "constants/DailyDepartmentReleasedTests"

export const fetchDailyDepartmentReleasedTestsRequest = (startDate, endDate, agency, department) =>{
    return {
        type : FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_REQUEST,
        payload : {
            startDate,
            endDate,
            agency,
            department
        }
    }
}

export const fetchDailyDepartmentReleasedTestsSuccess = (payload) =>{
    return {
        type : FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_SUCCESS,
        payload : payload
    }
}

export const fetchDailyDepartmentReleasedTestsFailure = (errorMessage) =>{
    return {
        type : FETCH_DAILY_DEPARTMENT_RELEASED_TESTS_FAILURE,
        payload : errorMessage
    }
}